var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-password-fields"},[_c('password-input',{staticClass:"mt-0",attrs:{"setup":{
      'func': _vm.modelSetter,
      'args': {
        'model': this,
        'key': 'pass',
        'prefix': 'new_',
        'validation': ("required|min:" + _vm.PASSWORD_MIN_SYMBOLS),
        'supportButtons': false
      },
    }}}),(_vm.isCapsLockActive)?_c('caps-lock-is-active-message'):_vm._e(),_c('password-input',{staticClass:"mb-1",attrs:{"setup":{
      'func': _vm.modelSetter,
      'args': {
        'model': this,
        'key': 'confirmPass',
        'prefix': 'new_',
        'validation': ("required|min:" + _vm.PASSWORD_MIN_SYMBOLS),
        'supportButtons': false
      },
    }}}),(!_vm.arePasswordsEqual)?_c('small',{staticClass:"text-danger"},[_vm._v(" "+_vm._s(_vm.$t('passwords_not_equal_message'))+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }